import { parseCookies } from '@cian/utils';
import { TReduxStore } from '../../../shared/types/redux';
import { fetchTeaser } from '../../repositories/teaser';
import { EBannerType, IPostViewEvent } from './types';

export function sendFSKPostViewAnalytic(store: TReduxStore) {
  const {
    developer,
    user: { userId },
  } = store.getState();

  if (developer && developer.specProjectType !== 'fsk') {
    return;
  }

  const postViewEvent: IPostViewEvent = {
    user_id: userId || null,
    pageType: 'SpecialPromoLanding',
    device_type: 'desktop',
    cid: parseCookies(document.cookie)['_CIAN_GK'],
    items: [
      {
        action: 'show',
        bannerType: EBannerType.FSK,
        bannerPlace: 'page',
        timestamp: Date.now(),
        dl: document.location.href,
      },
    ],
  };

  fetchTeaser(postViewEvent);
}
